import { useMemo } from 'react';

import { PairDayData, PairToken } from '@app/types/pool';

interface Props {
  reserve0: string;
  reserve1: string;
  pairAddress: string;
  token0: PairToken;
  token1: PairToken;
  token0Price: string;
  token1Price: string;
  dayData?: PairDayData[] | undefined;
}

function getAprValue(todayDailyFeeUSD: number, reserveUSD: number) {
  return ((todayDailyFeeUSD * 365) / reserveUSD) * 100;
}

export function usePairAprV2({ dayData }: Props) {
  return useMemo(() => {
    if (!dayData) {
      return {
        prevApr: null,
        currentApr: null
      };
    }

    const todayDailyFee = dayData[0] ? dayData[0].dailyFeeUSD : 0;
    const todayDailyReserve = dayData[0] ? dayData[0].reserveUSD : 0;
    const prevDailyFee = dayData[1] ? dayData[1].dailyFeeUSD : 0;
    const prevDailyReserve = dayData[0] ? dayData[0].reserveUSD : 0;

    return {
      prevApr: getAprValue(+prevDailyFee, +prevDailyReserve),
      currentApr: getAprValue(+todayDailyFee, +todayDailyReserve)
    };
  }, [dayData]);
}
